import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizenVerifyPassword} from './citizen-verify-password.model';
import * as CitizenVerifyPasswordActions from './citizen-verify-password.actions';

export const citizenVerifyPasswordsFeatureKey = 'citizenVerifyPasswords';

export interface State extends EntityState<CitizenVerifyPassword> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizenVerifyPassword> = createEntityAdapter<CitizenVerifyPassword>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizenVerifyPasswordActions.addCitizenVerifyPassword,
    (state, action) => adapter.addOne(action.citizenVerifyPassword, state)
  ),
  on(CitizenVerifyPasswordActions.upsertCitizenVerifyPassword,
    (state, action) => adapter.upsertOne(action.citizenVerifyPassword, state)
  ),
  on(CitizenVerifyPasswordActions.addCitizenVerifyPasswords,
    (state, action) => adapter.addMany(action.citizenVerifyPasswords, state)
  ),
  on(CitizenVerifyPasswordActions.upsertCitizenVerifyPasswords,
    (state, action) => adapter.upsertMany(action.citizenVerifyPasswords, state)
  ),
  on(CitizenVerifyPasswordActions.updateCitizenVerifyPassword,
    (state, action) => adapter.updateOne(action.citizenVerifyPassword, state)
  ),
  on(CitizenVerifyPasswordActions.updateCitizenVerifyPasswords,
    (state, action) => adapter.updateMany(action.citizenVerifyPasswords, state)
  ),
  on(CitizenVerifyPasswordActions.deleteCitizenVerifyPassword,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizenVerifyPasswordActions.deleteCitizenVerifyPasswords,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizenVerifyPasswordActions.loadCitizenVerifyPasswords,
    (state, action) => adapter.setAll(action.citizenVerifyPasswords, state)
  ),
  on(CitizenVerifyPasswordActions.clearCitizenVerifyPasswords,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
